export default __webpack_public_path__ + "static/media/(5).94763285.jpeg";